require('./accountInterveners.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ utilities
const docType = require('utilities/contactCenter/typeDocumentHelper');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

class AccountInterveners extends React.Component {
    getDocumentInfo(intervener) {
        const labelsDoc = [
            {type: "s", value: "interveners-labelCif"},
            {type: "c", value: "interveners-labelNIE"},
            {type: "i", value: "interveners-labelForeignCard"},
            {type: "n", value: "interveners-labelNIF"},
            {type: "p", value: "interveners-labelPassport"},
            {type: "da", value: "interveners-labelDEDNI"},
            {type: "pa", value: "interveners-labelDEPassport"},
            {type: "cc", value: "interveners-labelPTDNI"},
            {type: "pp", value: "interveners-labelPTPassport"},
            {type: "dn", value: "interveners-labelNLDNI"},
            {type: "pn", value: "interveners-labelNLPassport"},
            {type: "nd", value: "interveners-labelUndefinedDocument"}
        ];

        if(!intervener.identificationDocument) return null
        const documentType = intervener.identificationDocument.type.toLowerCase();
        const intervenerIdType = intervener.identification.type.toLowerCase();
        const intervenerDoc = docType.getDoc(labelsDoc,intervener.identificationDocument.type, intervener.identificationDocument.code);

        if ((intervenerIdType !== "j" && documentType !== "s") || (intervener.type.toLowerCase() === "titular" && intervenerIdType === "j" && documentType === "s")){
            return <p className="ok-informative-list-item__extra-content-body-text-cif">{intervenerDoc.label}: {intervenerDoc.number}</p>;
        }

        return null
    }

    buildInformativeListItems() {
        const { immInterveners, accountId } = this.props;
        const list = immInterveners.get('list').toJS();

        return list.map((intervener, index) => {
            let removeIntervener;
            const documentInfo = __CONTACT_CENTER__ ? this.getDocumentInfo(intervener) : null;

            if (intervener.isRemovable) {
                const removeIntervenerUri = `/myprofile/accounts/${accountId}/intervener/${index}/remove`;

                removeIntervener = (
                    <OKLink modifier="emphasize" to={removeIntervenerUri}>
                        <FormattedText value="accountInterveners-remove" />
                    </OKLink>
                );
            }

            return (
                <OKInformativeListItem
                    key={index}
                    title={intervener.type}
                    bodyText={intervener.name}
                    bodyWordBreak={false}
                >
                    <ContactCenterRender>
                        {documentInfo}
                    </ContactCenterRender>
                    {removeIntervener}
                </OKInformativeListItem>
            );
        });
    }

    render() {
        const { immInterveners } = this.props;
        const headerTitle = formatText('accountInterveners-title');
        const isLoading = immInterveners.get('isLoading');
        const error = immInterveners.get('error');
        let interveners = [];
        let list;

        if (isLoading) {
            list = <LoadingSection />;
        } else if (immInterveners.get('list').size > 0) {
            interveners = this.buildInformativeListItems();

            if (interveners.length > 0) {
                list = <OKInformativeList>{interveners}</OKInformativeList>
            }
        } else if (__CONTACT_CENTER__ && error) {
            const serviceErrorText = formatText('interveners-serviceError');
            const serviceErrorDescription = formatText('interveners-serviceErrorDescription');

            list = (<span><p className="account-interveners__error">{serviceErrorText}</p>
                <p className="account-interveners__error">{serviceErrorDescription}: {error.getIn(['error','description'])}</p></span>);
        }

        return (
            <div className="card-contract">
                <div className="account-interveners__title">
                    <OKBoxTitle value={headerTitle}
                        size="medium"
                        isNotSeparator={true}
                    />
                </div>
                <div className="account-interveners__list">
                    {list}
                </div>
            </div>
        );
    }
}

AccountInterveners.propTypes = {
    immInterveners: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired
};

module.exports = AccountInterveners;
